import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleQuestion } from '@fortawesome/free-regular-svg-icons'
import { NFT } from '@thirdweb-dev/sdk'
import { truncateAddress } from '~/components/shared/address'
import { getChainExplorerLink, getChainNameFromId } from '~/components/shared/chain'
import { Tooltip } from '~/components/Tooltip'
import { Collection } from '~/domain/Collection'
import styles from './index.module.scss'
import linkStyles from '~/components/Link/index.module.scss'

interface NftDetailsProps {
  nft: NFT
  collection: Collection
}

export const NftDetailsHeader: React.FC = () => {
  return (
    <h1 className={ styles['nft-details__title'] }>
      Details
    </h1>
  )
}

export const NftDetailsMain: React.FC<NftDetailsProps> = ({ nft, collection }) => {
  const creatorFeeTooltip =
    'Fee taken from secondary sales which is shared among Legend, ' +
    'the sports organizer, and/or the awarded club or athlete'

  return (
    <ul className={ styles['nft-details__list'] } >
      <li className={ styles['nft-details__item'] } >
        <span>Contract address</span>
        <span>
          <a
            href={ getChainExplorerLink(collection.contract.chainId, collection.contract.address) }
            target="_blank"
            rel="noreferrer"
            className={ linkStyles['link'] }
          >
            { truncateAddress(collection.contract.address) }
          </a>
        </span>
      </li>

      <li className={ styles['nft-details__item'] } >
        <span>Token ID</span>
        <span>{ nft.metadata.id }</span>
      </li>

      <li className={ styles['nft-details__item'] } >
        <span>Token standard</span>
        <span>{ nft.type }</span>
      </li>

      <li className={ styles['nft-details__item'] } >
        <span>Chain</span>
        <span>{ getChainNameFromId(collection.contract.chainId) }</span>
      </li>

      <li className={ styles['nft-details__item'] } >
        <span>
          Creator fee { }

          <FontAwesomeIcon
            icon={ faCircleQuestion }
            data-tooltip-id="creator-fee"
            data-tooltip-content={ creatorFeeTooltip }
          />

          <Tooltip id="creator-fee" />
        </span>
        <span>{ collection.contract.fee }%</span>
      </li>
    </ul>
  )
}

export const NftDetails: React.FC<NftDetailsProps> = ({ nft, collection }) => {
  return (
    <div
      data-testid="nft-details"
      className={ styles['nft-details'] }
    >
      <NftDetailsHeader/>

      <NftDetailsMain
        nft={ nft }
        collection={ collection }
      />
    </div>
  )
}
